export default __webpack_public_path__ + "static/536-3e9a977dc63133325edcf8f2c9fffc6e.gif";